import {
    FETCH_DESIGNATION_BASED_REQUEST,
    FETCH_DESIGNATION_BASED_SUCCESS,
    FETCH_DESIGNATION_BASED_FAILURE,
} from "../constants/DesignationbasedConstants";

const initialState = {
    loading: false,
    data: [],
    error: null,

    empLoading: false,
    empData: [],
    empError: null
};

const DesignationBasedReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_DESIGNATION_BASED_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_DESIGNATION_BASED_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
            };

        case FETCH_DESIGNATION_BASED_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

            default:
                return state;
        }
};


export default DesignationBasedReducer;
